<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">拒绝原因（可选）</label>
      <textarea v-model="adminNote" rows="3"
        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-200"
        placeholder="请输入拒绝原因..."></textarea>
    </div>
    <div class="flex justify-end gap-3">
      <button type="button" @click="$emit('cancel')"
        class="cancel-btn">
        取消
      </button>
      <button type="button" @click="handleSubmit"
        class="danger-btn">
        确认拒绝
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const emit = defineEmits<{
  (e: 'submit', adminNote: string | null): void
  (e: 'cancel'): void
}>()

const adminNote = ref('')

const handleSubmit = () => {
  emit('submit', adminNote.value || null)
}
</script>
